export const getCurrentNeighborhoods = ({ neighborhoods = {} } = {}) =>
  neighborhoods;

export default getCurrentNeighborhoods;
